var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.handleOutsideClick,
          expression: "handleOutsideClick",
        },
      ],
      attrs: { id: "mobile_view_filter" },
    },
    [
      _c("button", {
        staticClass: "bb-mobile-view-filter-toggle-btn",
        domProps: { innerHTML: _vm._s(_vm.selectedViewIcon) },
        on: { click: _vm.toggle },
      }),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isOpen,
              expression: "isOpen",
            },
          ],
          staticClass: "bb-mobile-view-filter",
        },
        [
          _c("div", { staticClass: "mobile-view-filter-title" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("calendarFilters.mobileViewFilter.title"))),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "mobile-view-filter-options" },
            _vm._l(_vm.calendarViews, function (view) {
              return _c(
                "div",
                {
                  key: view.value,
                  staticClass: "mobile-view-filter-option-item",
                  on: {
                    click: function ($event) {
                      return _vm.selectView(view.value)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "option-item-present" }, [
                    _c("div", {
                      staticClass: "bb-badge",
                      domProps: { innerHTML: _vm._s(view.icon) },
                    }),
                    _c("span", [_vm._v(_vm._s(view.text))]),
                  ]),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: view.value === _vm.selectedView,
                          expression: "view.value === selectedView",
                        },
                      ],
                      staticClass: "option-item-selected",
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "feather feather-check",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "12",
                            height: "12",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "3",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        },
                        [
                          _c("polyline", {
                            attrs: { points: "20 6 9 17 4 12" },
                          }),
                        ]
                      ),
                    ]
                  ),
                ]
              )
            }),
            0
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }